// extracted by mini-css-extract-plugin
export default {"link":"FooterControls_link__pKjTK","button":"FooterControls_button__7S8to"};